import { render } from "./EtatColisParCasierPage.vue?vue&type=template&id=336fc18a&ts=true"
import script from "./EtatColisParCasierPage.vue?vue&type=script&lang=ts"
export * from "./EtatColisParCasierPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__